import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">

      {/* ── Main Footer ───────────────────────────────────────────── */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">

            {/* ── Brand ───────────────────────────────────────────── */}
            <div className="footer-section footer-brand">

              <div className="footer-logo">
                <img
                  src="/logo.png"
                  alt="Annapurna Axis Trading Pvt. Ltd."
                  className="footer-logo-img"
                />
              </div>

              <p className="footer-about">
                Annapurna Axis Trading Pvt. Ltd. is a professional sourcing
                and international trading company helping businesses source
                products, manage quality inspection, packaging, logistics,
                customs clearance, and door-to-door delivery.
              </p>

              <p className="footer-about footer-tagline">
                <strong>From trusted suppliers to your final destination.</strong>
              </p>

              <div className="footer-social">
                <a
                  href="https://www.facebook.com/bikal2"
                  className="footer-social-link"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
              </div>
            </div>


            {/* ── Our Services ───────────────────────────────────── */}
            <div className="footer-section">

              <h4 className="footer-heading">Our Services</h4>

              <ul className="footer-links">

                <li>
                  <Link to="/services">
                    Product Sourcing
                  </Link>
                </li>

                <li>
                  <Link to="/services">
                    Supplier Verification
                  </Link>
                </li>

                <li>
                  <Link to="/services">
                    Quality Inspection
                  </Link>
                </li>

                <li>
                  <Link to="/services">
                    Product Packaging
                  </Link>
                </li>

                <li>
                  <Link to="/services">
                    Shipping & Logistics
                  </Link>
                </li>

                <li>
                  <Link to="/services">
                    Customs Clearance
                  </Link>
                </li>

                <li>
                  <Link to="/services">
                    Amazon FBA Delivery
                  </Link>
                </li>

              </ul>

            </div>


            {/* ── Quick Links ────────────────────────────────────── */}
            <div className="footer-section">

              <h4 className="footer-heading">Quick Links</h4>

              <ul className="footer-links">

                <li>
                  <Link to="/">
                    Home
                  </Link>
                </li>

                <li>
                  <Link to="/about">
                    About Us
                  </Link>
                </li>

                <li>
                  <Link to="/products">
                    Products
                  </Link>
                </li>

                <li>
                  <Link to="/services">
                    Services
                  </Link>
                </li>

                <li>
                  <Link to="/contact">
                    Contact Us
                  </Link>
                </li>

              </ul>

            </div>


            {/* ── Contact ────────────────────────────────────────── */}
            <div className="footer-section">

              <h4 className="footer-heading">Contact Us</h4>

              <div className="footer-contact-list">

                {/* Location */}
                <div className="footer-contact-item">

                  <div className="contact-info-icon">
                    <i className="fas fa-location-dot"></i>
                  </div>

                  <span>
                    Chauthe, Pokhara
                    <br />
                    Kaski, Nepal
                  </span>

                </div>


                {/* Phone */}
                <div className="footer-contact-item">

                  <div className="contact-info-icon">
                    <i className="fas fa-phone"></i>
                  </div>

                  <a href="tel:+9779860105010">
                    +977 9860105010 | +86 15030709205
                  </a>

                </div>


                {/* Email */}
                <div className="footer-contact-item">

                  <div className="contact-info-icon">
                    <i className="fas fa-envelope"></i>
                  </div>

                  <a href="mailto:info@annapurnaaxis.com">
                    info@annapurnaaxis.com
                  </a>

                </div>


                {/* Business Hours */}
                <div className="footer-contact-item">

                  <div className="contact-info-icon">
                    <i className="fas fa-clock"></i>
                  </div>

                  <span>
                    Mon – Sat: 9:00 AM – 6:00 PM
                  </span>

                </div>

              </div>

            </div>

          </div>
        </div>
      </div>


      {/* ── Service Highlights ───────────────────────────────────── */}
      <div className="footer-trust">

        <div className="container">

          <div className="footer-trust-grid">

            <div className="footer-trust-item">
              <span className="footer-trust-icon">✓</span>
              <div>
                <strong>Trusted Sourcing</strong>
                <span>Reliable supplier network</span>
              </div>
            </div>

            <div className="footer-trust-item">
              <span className="footer-trust-icon">✓</span>
              <div>
                <strong>Quality Inspection</strong>
                <span>Before shipment</span>
              </div>
            </div>

            <div className="footer-trust-item">
              <span className="footer-trust-icon">✓</span>
              <div>
                <strong>Global Logistics</strong>
                <span>China to worldwide</span>
              </div>
            </div>

            <div className="footer-trust-item">
              <span className="footer-trust-icon">✓</span>
              <div>
                <strong>Door-to-Door Delivery</strong>
                <span>Complete trade solution</span>
              </div>
            </div>

          </div>

        </div>

      </div>


      {/* ── Footer Bottom ────────────────────────────────────────── */}
      <div className="footer-bottom">

        <div className="container">

          <div className="footer-bottom-content">

            <p>
              © {new Date().getFullYear()} Annapurna Axis Trading Pvt. Ltd.
              All rights reserved.
            </p>

            <div className="footer-bottom-links">

              <Link to="/privacy-policy">
                Privacy Policy
              </Link>

              <Link to="/terms">
                Terms of Service
              </Link>

              <Link to="/contact">
                Contact
              </Link>

            </div>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;